/* src/app/components/lead-details/check-list/ppl-checklist/checklist.component.css */
/*# sourceMappingURL=checklist.component-KHXLTIIQ.css.map */
